import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip, Image } from "react-bootstrap";
import DynamicTable from "../widgets/dynamicTable/DynamicTable.jsx";
import HelperMetiers360 from "../../services/HelpersMetiers360.js";


const PackageTableComponent = ({ packages, readOne: readOneSlug }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const packagesToDisplay = packages ?? [];


    const sortType = [
        {
            value: 'thumbnail',
            label: 'Vignette',
            test: HelperMetiers360.isArrayContainsValue(packagesToDisplay, "thumbnail"),
            display: (pkg) => pkg.thumbnail ? (
                <OverlayTrigger placement="right" overlay={<Tooltip><Image src={pkg.thumbnail} /></Tooltip>}>
                    <Image src={pkg.thumbnail} className="img-overlay" thumbnail />
                </OverlayTrigger>
            ) : "-",
            flatDisplay: (pkg) => pkg.thumbnail
        },
        {
            value: 'name',
            label: "Nom du Package",
            test: HelperMetiers360.isArrayContainsValue(packagesToDisplay, "name"),
            method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.name, b.name),
            display: (pkg) => pkg.name
        },
        {
            value: 'description',
            label: "Description",
            test: HelperMetiers360.isArrayContainsValue(packagesToDisplay, "description"),
            display: (pkg) => pkg.description ?? "-"
        },
        {
            value: 'apkCount',
            label: "Nb APKs",
            test: HelperMetiers360.isArrayContainsValue(packagesToDisplay, "apkCount"),
            method: (a, b) => a.apkCount - b.apkCount,
            display: (pkg) => pkg.apkCount
        },
        {
            value: 'clientCount',
            label: "Nb clients",
            test: HelperMetiers360.isArrayContainsValue(packagesToDisplay, "clientCount"),
            method: (a, b) => a.clientCount - b.clientCount,
            display: (pkg) => pkg.clientCount || "-"
        },
        {
            value: 'createdAt',
            label: "Date création",
            test: HelperMetiers360.isArrayContainsValue(packagesToDisplay, "createdAt"),
            method: (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
            display: (pkg) => HelperMetiers360.getdisplayDateType(pkg.createdAt, 'day')
        },
        {
            value: 'updatedAt',
            label: "Date modification",
            test: HelperMetiers360.isArrayContainsValue(packagesToDisplay, "updatedAt"),
            method: (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt),
            display: (pkg) => HelperMetiers360.getdisplayDateType(pkg.updatedAt, 'day')
        }
    ];


    const onSelectPackage = (uniqueID) => {
        if (readOneSlug)
            navigate(readOneSlug.replace(':uniqueId', uniqueID), { state: { olderSearchParams: location.search } });
    }


    return <DynamicTable
        contentTable={packagesToDisplay}
        contentSort={sortType}
        valueInitSort="createdAt"
        index='uniqueId'
        handleClick={onSelectPackage}
        withParams={true}
        tableName="packageTable"
        filename="packages" />;
}

PackageTableComponent.propTypes = {
    packages: PropTypes.array.isRequired,
}

export default PackageTableComponent;